export class CannotChangeDefaultDepartmentAsRecordingSessionsExistForTodayError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, CannotChangeDefaultDepartmentAsRecordingSessionsExistForTodayError.prototype)
  }
}
